module.exports = __webpack_public_path__ + "static/media/08 - 13122.NHCLA.MOT.DEC.ORD.0b043a83.pdf";